module.exports = __webpack_public_path__ + "img/Icon_1.c8d7dfe0.svg";